/**
 * "Earlier messages not loaded", drawn where PD-1 says they go.
 *
 * `gap_before_seq` is COMPUTED, and on the shape this screen exists for — a
 * flipped pebble whose short legacy half fits under its cap while its long split
 * half does not — it is well inside the array, after the whole legacy block, not
 * at the head. PD-1 §1.3 records the round where hard-coding 0 drew this banner
 * above a complete transcript and rendered the real hole as two adjacent
 * bubbles. So this component takes the seq and never guesses one.
 *
 * It is also a CONSERVATIVE marker, not a proof of absence: an untruncated
 * source may cover part of what the truncated one dropped. The wording says
 * "older than this point", which is the direction PD-1 actually guarantees.
 */
import type { GapRow } from './trace';

export default function GapMarker({ row }: { row: GapRow }) {
  return (
    <div className="flex items-center gap-3 py-2" data-testid="gap-marker">
      <div className="flex-1 border-t border-dashed border-amber-400" />
      <div className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1">
        earlier messages not loaded — turns older than this point were dropped by{' '}
        {row.sources.length > 0 ? row.sources.join(', ') : 'a truncated source'}. Raise the transcript limit to see
        them.
      </div>
      <div className="flex-1 border-t border-dashed border-amber-400" />
    </div>
  );
}
